import * as Yup from "yup"
import "react-quill/dist/quill.snow.css"
import ReactQuill, {Quill} from "react-quill"
import FormInput from "../form-builder/form-input"
import FormBuilder from "../form-builder/form-builder"
import {BaSeButton} from "@base/react"
import ApiPlannings from "../../services/planning"
import {toast} from "react-toastify";
import ToastContent from "../toastContent";
import {useState} from "react"
import {eventTag} from "../../services/utils";

const icons = Quill.import("ui/icons")
icons.bold = `
  <svg title="Negrito" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1C0 0.46875 0.4375 0 1 0H2.5H3H7C9.1875 0 11 1.8125 11 4C11 5 10.625 5.90625 10.0625 6.59375C11.2188 7.28125 12 8.5625 12 10C12 12.2188 10.1875 14 8 14H3H2.5H1C0.4375 14 0 13.5625 0 13C0 12.4688 0.4375 12 1 12H1.5V7V2H1C0.4375 2 0 1.5625 0 1ZM7 6C8.09375 6 9 5.125 9 4C9 2.90625 8.09375 2 7 2H3.5V6H7ZM3.5 8V12H8C9.09375 12 10 11.125 10 10C10 8.90625 9.09375 8 8 8H7H3.5Z" fill="#484848"/>
  </svg>
`
icons.italic = `
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 1C4 0.46875 4.4375 0 5 0H11C11.5312 0 12 0.46875 12 1C12 1.5625 11.5312 2 11 2H9.15625L5 12H7C7.53125 12 8 12.4688 8 13C8 13.5625 7.53125 14 7 14H1C0.4375 14 0 13.5625 0 13C0 12.4688 0.4375 12 1 12H2.8125L7 2H5C4.4375 2 4 1.5625 4 1Z" fill="#484848"/>
  </svg>
`
icons.underline = `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 1C0.5 0.46875 0.9375 0 1.5 0H4.5C5.03125 0 5.5 0.46875 5.5 1C5.5 1.5625 5.03125 2 4.5 2H4V6C4 7.65625 5.34375 9 7 9C8.65625 9 10 7.65625 10 6V2H9.5C8.9375 2 8.5 1.5625 8.5 1C8.5 0.46875 8.9375 0 9.5 0H12.5C13.0312 0 13.5 0.46875 13.5 1C13.5 1.5625 13.0312 2 12.5 2H12V6C12 8.78125 9.75 11 7 11C4.21875 11 2 8.78125 2 6V2H1.5C0.9375 2 0.5 1.5625 0.5 1ZM0 13C0 12.4688 0.4375 12 1 12H13C13.5312 12 14 12.4688 14 13C14 13.5625 13.5312 14 13 14H1C0.4375 14 0 13.5625 0 13Z" fill="#484848"/>
  </svg>
`
icons.link = `
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8.15625L14.5 11.6562C12.75 13.4375 9.875 13.4375 8.125 11.6562C6.5625 10.0938 6.34375 7.65625 7.625 5.84375L7.65625 5.8125C8 5.34375 8.625 5.25 9.0625 5.5625C9.5 5.875 9.625 6.5 9.28125 6.96875L9.25 7C8.53125 8 8.65625 9.375 9.53125 10.25C10.5 11.25 12.0938 11.25 13.0938 10.25L16.5938 6.75C17.5938 5.75 17.5938 4.15625 16.5938 3.1875C15.7188 2.3125 14.3438 2.1875 13.3438 2.90625L13.3125 2.9375C12.8438 3.28125 12.2188 3.15625 11.9062 2.71875C11.5938 2.28125 11.6875 1.65625 12.125 1.3125L12.1875 1.28125C14 0 16.4375 0.21875 18 1.78125C19.7812 3.53125 19.7812 6.40625 18 8.15625ZM1.78125 7.4375L5.28125 3.90625C7.0625 2.15625 9.90625 2.15625 11.6875 3.90625C13.25 5.46875 13.4375 7.9375 12.1562 9.75L12.125 9.78125C11.8125 10.25 11.1562 10.3438 10.7188 10.0312C10.2812 9.71875 10.1562 9.09375 10.5 8.625L10.5312 8.59375C11.25 7.5625 11.125 6.21875 10.25 5.34375C9.28125 4.34375 7.6875 4.34375 6.6875 5.34375L3.1875 8.84375C2.21875 9.8125 2.21875 11.4062 3.1875 12.4062C4.0625 13.2812 5.4375 13.4062 6.4375 12.6875L6.46875 12.6562C6.9375 12.3125 7.5625 12.4375 7.875 12.875C8.1875 13.3125 8.09375 13.9375 7.65625 14.2812L7.59375 14.3125C5.8125 15.5938 3.34375 15.375 1.78125 13.8125C0 12.0625 0 9.1875 1.78125 7.4375Z" fill="#484848"/>
  </svg>
`

icons.list.bullet = icons.list.bullet.replace('<svg', `<svg title="Lista com marcadores"`);
icons.list.ordered = icons.list.ordered.replace('<svg', `<svg title="Lista numerada"`);
// icons.code = `
//   <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M12.375 2.0625C12.9062 2.21875 13.2188 2.75 13.0625 3.28125L9.0625 17.2812C8.90625 17.8125 8.375 18.125 7.84375 17.9688C7.3125 17.8125 7 17.2812 7.15625 16.75L11.1562 2.75C11.3125 2.21875 11.8438 1.90625 12.375 2.0625ZM14.9062 5.8125C15.2812 5.40625 15.9375 5.40625 16.3125 5.8125L19.8125 9.3125C20.2188 9.6875 20.2188 10.3438 19.8125 10.7188L16.3125 14.2188C15.9375 14.625 15.2812 14.625 14.9062 14.2188C14.5 13.8438 14.5 13.1875 14.9062 12.8125L17.6875 10L14.9062 7.21875C14.5 6.84375 14.5 6.1875 14.9062 5.8125ZM5.3125 5.8125C5.71875 6.1875 5.71875 6.84375 5.3125 7.21875L2.53125 10L5.3125 12.8125C5.71875 13.1875 5.71875 13.8438 5.3125 14.2188C4.9375 14.625 4.28125 14.625 3.90625 14.2188L0.40625 10.7188C0 10.3438 0 9.6875 0.40625 9.3125L3.90625 5.8125C4.28125 5.40625 4.9375 5.40625 5.3125 5.8125Z" fill="#484848"/>
//   </svg>
// `

const MAX_CHARS = 1000;

const stripHtml = (value = "") =>
  value.replace(/<[^>]+>/g, "").replace(/&nbsp;?/g, " ").trim()

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  description: Yup.string().test(
      "max-plain-length",
      `A descrição deve ter no máximo ${MAX_CHARS} caracteres.`,
      (value) => stripHtml(value).length <= MAX_CHARS
    )
})
const quillModules = {
  toolbar: [
    [{ size: ["small", false, "large"] }, { color: [] }, "bold", "italic", "underline", { link: true }, { list: "ordered" }, { list: "bullet" }],
  ],
}

const api = ApiPlannings()

export function OpinionForm({ planningId = null, opinion = {}, back, forceUpdateOpinions, event }) {
  const formDefault = {
    id: opinion?.id ?? null,
    name: opinion?.name || '',
    description: opinion?.description || '',
    action: "publish"
  }
  const [form, setForm] = useState(formDefault)
  const isPublished = opinion?.status === 'published'
  const isDisabled = isPublished

  const fnSubmit = async (values, helpers) => {
    helpers.setSubmitting(true)
    const dataObj = {
      name: values?.name,
      description: values?.description,
      published: true
    }
    try {
      if (!form?.id) {
        const {status, data} = await api.createOpinion(planningId, dataObj)
        if (data) {
          setForm((prev) => {
            return {
              ...prev,
              id: data?.id,
              name: data?.name,
              description: data?.description,
            }
          })
          if (status === 203) {
            toast.warning(
              <ToastContent
                description={data?.detail}
                title="Ops!"
              />,
              {
                autoClose: 5000,
                pauseOnFocusLoss: false,
              }
            )
          } else {
            toast.success(
              <ToastContent
                description="Acompanhamento salvo."
                title="Sucesso!"
              />,
              {
                autoClose: 5000,
                pauseOnFocusLoss: false,
              }
            )
            eventTag(
              event?.name,
              event?.category,
              "submit",
              "Cadastro de comentário"
            )
            back()
          }
        }
      } else {
        const {data, status} = await api.updateOpinion(planningId, form?.id, dataObj)
        if (data) {
          setForm((prev) => {
            return {
              ...prev,
              id: data?.id,
              name: data?.name,
              description: data?.description,
            }
          })
          if (status === 203) {
            toast.warning(
              <ToastContent
                description={data?.detail}
                title="Ops!"
              />,
              {
                autoClose: 5000,
                pauseOnFocusLoss: false,
              }
            )
          } else {
            toast.success(
              <ToastContent
                description={'Acompanhamento publicado.'}
                title="Sucesso!"
              />,
              {
                autoClose: 5000,
                pauseOnFocusLoss: false,
              }
            )
            eventTag(
              event?.name,
              event?.category,
              "submit",
              "Comentário publicado"
            )
            back()
          }
        }
      }
    } catch (e) {
      console.warn(e)
    } finally {
      helpers.setSubmitting(false)
      forceUpdateOpinions()
    }
  }

  return (
    <FormBuilder
      initialValues={form}
      validationSchema={validationSchema}
      onSubmit={(values, helpers) => {
        fnSubmit(values, helpers)
      }}
      classCustom={isPublished ? 'only-view' : ''}
    >
      {({ isSubmitting, values, errors, setFieldValue, setFieldTouched }) => {
        const plainLength = stripHtml(values.description).length
        const hasErrors = !!Object.keys(errors).length

        return (
          <>
            <FormInput
              id="name"
              name="name"
              isDisabled={isSubmitting || isDisabled}
              label="Título do comentário"
              placeholder="Escolha um título para o comentário"
              maxLength={40}
            />

            <div className={"wrapper-input"}>
              <div className="BaSe--input">
                <div className="BaSe--input-wrapper-label">
                  <label className="BaSe--input-label">
                    Descrição do comentário
                  </label>
                </div>
                <ReactQuill
                  id="description"
                  theme="snow"
                  readOnly={isSubmitting || isDisabled}
                  value={values.description}
                  modules={quillModules}
                  onChange={(content) => setFieldValue("description", content)}
                  onBlur={async () => {
                    setFieldTouched("description", true)
                  }}
                  placeholder="Digite aqui a explicação para o comentário"
                  className="BaSe--input-input"
                />
                {
                  !isPublished ? (
                    <div className={"quill__small-text "+(plainLength > MAX_CHARS ? "error" : "")}>
                      <span>Máximo {MAX_CHARS} caracteres</span>
                      <span>
                        {plainLength}/{MAX_CHARS}
                      </span>
                    </div>
                  ) : ''
                }
              </div>
            </div>

            {
              !isPublished ? (
                <div className="wrapper-buttons">
                  <BaSeButton
                    type="secondary"
                    buttonType="button"
                    isDisabled={ isSubmitting || isDisabled}
                    onClick={(event) => {
                      event.preventDefault()
                      back()
                    }}
                    color="#005eb8"
                    value="Voltar"
                  />
                  <BaSeButton
                    color="#2E5DE6"
                    value="Comentar"
                    buttonType="submit"
                    onClick={() => {
                      setFieldValue("action", "publish")
                    }}
                    isDisabled={hasErrors || isSubmitting || isDisabled}
                  />
                </div>
              ) : (
                <div className="wrapper-buttons">
                  <BaSeButton
                    type="secondary"
                    buttonType="button"
                    onClick={(event) => {
                      event.preventDefault()
                      back()
                    }}
                    color="#005eb8"
                    value="Voltar"
                  />
                </div>
              )
            }
          </>
        )
      }}
    </FormBuilder>
  )
}
